export class User {
    id: number;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    token?: string;
    refreshToken?: string;
    isAdmin?:boolean;
    isSuperAdmin?:boolean;
    roles?: string[];
    accessRights?: string[];
}

export class ComboData{
    constructor(text:string,value:string){
        this.value = value;
        this.text = text;
    }
    id:number;
    text:string;
    value:string;
    selectd = false;
}
